__turbopack_context__.v({
  "closeButton": "work-social-links-module-scss-module__jw1hhW__closeButton",
  "copyButton": "work-social-links-module-scss-module__jw1hhW__copyButton",
  "copyRow": "work-social-links-module-scss-module__jw1hhW__copyRow",
  "copyStatus": "work-social-links-module-scss-module__jw1hhW__copyStatus",
  "facebook": "work-social-links-module-scss-module__jw1hhW__facebook",
  "instagram": "work-social-links-module-scss-module__jw1hhW__instagram",
  "link": "work-social-links-module-scss-module__jw1hhW__link",
  "root": "work-social-links-module-scss-module__jw1hhW__root",
  "share": "work-social-links-module-scss-module__jw1hhW__share",
  "shareHeader": "work-social-links-module-scss-module__jw1hhW__shareHeader",
  "shareInstructions": "work-social-links-module-scss-module__jw1hhW__shareInstructions",
  "sharePanel": "work-social-links-module-scss-module__jw1hhW__sharePanel",
  "shareUrl": "work-social-links-module-scss-module__jw1hhW__shareUrl",
  "tiktok": "work-social-links-module-scss-module__jw1hhW__tiktok",
  "u-animation-bounce": "work-social-links-module-scss-module__jw1hhW__u-animation-bounce",
  "youtube": "work-social-links-module-scss-module__jw1hhW__youtube",
});
